module.exports = __webpack_public_path__ + "media/src/images/mypage/icon_facebook-6d6368d039a4b1d0fd2a28ec5a10fd86.png";